<template>
  <div class="main-view-padding has-header">
      <div class="header main" v-header-position-lock>
          <div class="align-left">
          </div>
          <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
          </div>
          <div class="align-right">
          </div>
      </div>
    <div style="font-size: 32px; text-align: left; color: #e51550; border-bottom:1px solid #ccc; padding: 5px; font-weight:400; margin-bottom:25px;">
      Stores
    </div>




    <div v-if="!loading && isSuperUser" style="overflow-y:auto; height: 800px;">
      <table class="table">
        <tr>
          <td>ID</td>
          <td>Name</td>
          <td>Aktiv</td>
        </tr>
        <tr v-for="externalSoftware in externalSoftwaresMap" v-bind:key="'es'+externalSoftware.id">
          <td>{{externalSoftware.id}}</td>
          <td>{{externalSoftware.name}}</td>
          <td><i class="fas fa-check-circle checkbox" :key="'cb-sess-eid'"
                 v-bind:class="{ false: !externalSoftware.active, true: externalSoftware.active }"
                 v-on:click="setExternalSoftwareActiveStatus(externalSoftware)"></i></td>
        </tr>
      </table>
    </div>
  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import button from '../uicomponents/button.vue';
export default {
 components: { button },
  name: 'superadminExternalSoftware',
  data () {
    return {
      loading: false,
      stores: [],
    }
  },
  created: function () {
    //console.log("CREATED");
  },
  mounted: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.companyId != undefined){
        this.refresh();
    }
  },
  computed: {
    ...mapGetters(['companyId', 'isSuperUser', 'externalSoftwaresMap']),
    headerButtons() {
      let view = this;
      let state= { buttons: [] };

      return state;
    },
  },
  watch: {
    companyId: function(val, oldVal) {
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function(force = false){
      let view = this;
      view.loading = true;
      Promise.all([
        view.$helpers.GetExternalSoftwaresMap(),
      ]).then(resp => {
        view.loading = false;
      });
    },
    setExternalSoftwareActiveStatus(externalSoftware){
        let view = this;
        externalSoftware.active = !externalSoftware.active;

        view.$helpers.SetExternalSoftwareActive(externalSoftware);
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
